export enum TransferContext {
    TransferFromChat = "TransferFromChat",
    TransferFromFeedback = "TransferFromFeedback",
    TokenGenerationFailure = "TokenGenerationFailure",
    WebchatLoadFailure = "WebchatLoadFailure",
    DirectLineConnectionFailure = "DirectLineConnectionFailure",
    BotNoResponse = "BotNoResponse",
    BotServiceFailure = "BotServiceFailure",
}
